import type { z } from 'zod/v4';
import { _isArray } from '@epihub/core/src/fn/array';
import { UNKNOWN_ERROR_SCOPE } from './const';
import { ObjectError } from './ObjectError';

export const ZodToObjectError = (data: any) => {
  if (data && data.name === 'ZodError') {
    // Assuming Zod v3
    const zodError = data as z.ZodError;

    const issues = zodError.issues?.reduce((acc, issue) => {
      const joined = issue.path.join('.');

      if (_isArray(issue.path) && issue.path.length > 0) {
        acc.fields[joined] ??= [];
        acc.fields[joined].push(JSON.stringify(issue));
        return acc;
      }

      acc.global.push(JSON.stringify(issue));
      return acc;
    }, { global: [] as string[], fields: {} as Record<string, string[]> });

    const obj = new ObjectError({
      message: 'Invalid input',
      scope: UNKNOWN_ERROR_SCOPE,
      shouldSkipLogs: true,
      global: issues?.global ?? [],
      fields: issues?.fields ?? {},
    });

    if (data.stack) {
      obj.stack;
    }

    return obj;
  }

  return null;
};
